var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bug"},[_vm._m(0),_c('kaobo')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text"},[_c('p'),_c('h2',[_vm._v("在港靠泊船只")])])
}]

export { render, staticRenderFns }